import React, { useState } from 'react'
// Components
import CreateMensajeria from '../../../components/public/Mensajeria/Create.Mensajeria'
import Error404 from '../../components/Error404'
import FooterBar from '../../components/Footer/FooterBar'
import { ToastContainer } from 'react-toastify'
import CreateServicio from '../../../components/public/Servicios/Create.servicio'
import Home from '../../../components/public/Home/Home'
import ToolBar from '../../../shared/components/ToolBar/ToolBar';

// Styles

// ! Routes
import { Route, Switch } from 'react-router-dom'


export default function RoutesPublic() {


  return (

    <div style={{ height: '100%' }}>
      <header>
        <ToolBar />
      </header>
      <Switch>
        <Route path='/' component={Home} exact />
        {/* <Route path='/newmensajeria' component={CreateMensajeria} exact />
        <Route path='/newservice' component= {CreateServicio} exact /> */}
        <Route component={Error404} />
      </Switch>
     
        
    
      <ToastContainer />
    </div>

  )
}
